import React, { useRef, useState, useEffect } from "react";
import { readFile } from "@Components/FileUploader/Utils/canvasUtils";
import ImageCropDialog from "@Components/FileUploader/ImageCropDialog";
import ImageDraft from "./ImageDraft";

interface IFileUploaderProps {
    onDraftImageRemove: () => void;
    onSetBuffer: (bufferIgm: any) => void;
    defaultImage: null | string;
    public_media_url?: string;
    defaultImageUrl?: string;
}

const PollImageUploader: React.FC<IFileUploaderProps> = ({
    onSetBuffer,
    onDraftImageRemove,
    defaultImage,
    public_media_url = "",
}) => {
    const hiddenFileInput = useRef<HTMLInputElement>(null);

    const [imageSrc, setImageSrc] = useState<any | null>(null);
    const [draftImage, setDraftImage] = useState<any>(null);

    useEffect(() => {
        if (defaultImage !== null) {
            const newImage = {
                src: `${public_media_url}/${defaultImage}`,
            };
            setDraftImage(newImage);
        }
    }, [defaultImage, public_media_url]);

    const emptyInputFile = () => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.value = "";
        }
    };

    const handleUploadChange = async (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        if (e.target.files && e.target.files.length > 0) {
            e.persist();
            const selectedFile: File = e.target.files[0];
            let imageDataUrl = (await readFile(selectedFile)) as string;
            setImageSrc(imageDataUrl);
        }
    };

    const handleCropCancel = () => {
        setImageSrc(null);
    };

    const handleSetCroppedImageFor = async (croppedImageUrl: string) => {
        const newImage = { src: croppedImageUrl };
        setDraftImage(newImage);
        emptyInputFile();
        setImageSrc(null);
    };

    const handelImageDraftRemove = async () => {
        onDraftImageRemove();
        setDraftImage(null);
    };

    return (
        <>
            <input
                aria-label="upload image"
                type="file"
                name="media"
                onChange={handleUploadChange}
                ref={hiddenFileInput}
                accept="image/*"
                style={{ display: "none" }}
            />

            <ImageDraft
                draftImage={draftImage}
                onRemoveImageDraft={handelImageDraftRemove}
            />

            {imageSrc && (
                <ImageCropDialog
                    imageUrl={imageSrc}
                    handleCancel={handleCropCancel}
                    setCroppedImageFor={handleSetCroppedImageFor}
                    setBuffer={onSetBuffer}
                />
            )}
        </>
    );
};

export default PollImageUploader;
